import Suppliers from "features/Supplier/SuppliersList/Suppliers";

const SuppliersPage: React.FC = () => {
  return <Suppliers />;
};

export default SuppliersPage;
